import {
    APP_RESET,
    APPS_RESET,
    APP_FOCUS,
    APP_DOWNLOADED,
    APPS_DOWNLOADED,
    APPS_PENDING,
    APPS_FAILED,
    APP_FAILED,
    APP_POSTING,
    APP_EDITING,
    APP_DELETED,
    APP_DELETING,
    APP_PICTURE_UPLOADING,
    APP_PICTURE_FAILED,
    APP_PICTURE_UPLOADED,
    APP_PICTURE_DELETING,
    APP_PUSH_SUBSCRIBED,
    APP_PUSH_SUBSCRIBED_RESET
} from './types';

export const INITIAL_STATE = {
    error: null,
    content: [],
    currentIndex: null,
    currentApplication: null,
    pending: false,
    sending: false,
    subscribedToPush: null
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case APP_RESET:
            return {
                ...state,
                error: INITIAL_STATE.error,
                currentIndex: INITIAL_STATE.currentIndex,
                sending: INITIAL_STATE.sending,
                currentApplication: INITIAL_STATE.currentApplication
            };
        case APP_PUSH_SUBSCRIBED_RESET:
            return {
                ...state,
                subscribedToPush: INITIAL_STATE.subscribedToPush
            };
        case APP_PUSH_SUBSCRIBED:
            return {
                ...state,
                subscribedToPush: action.payload
            };
        case APP_DELETED:
            let newState = {
                ...state,
                sending: false
            };

            newState.content = state.content.filter((app)  => {
                return app.id !== action.payload
            });

            if (state.currentApplication) {
                if (state.currentApplication.id === action.payload) {
                    newState.currentApplication = null;
                    newState.currentIndex = null;
                } else {
                    newState.currentIndex = newState.content.findIndex((app) => {
                        return newState.currentApplication.id === app.id
                    });
                }
            }

            return newState;
        case APPS_RESET:
            return INITIAL_STATE;
        case APPS_PENDING:
            return {
                ...state,
                pending: true
            };
        case APP_FOCUS:
            return {
                ...state,
                error: null,
                currentIndex: state.content.findIndex(app => {
                    return app.id === action.payload.id
                }),
                currentApplication: action.payload
            };
        case APP_DOWNLOADED:
            let newContent = [];
            let newIndex;
            let id = action.payload.id;
            let app = state.content.find(function (app) {
                return app.id === id
            });

            if (app) {
                let index = state.content.findIndex(stateApp => {
                    return stateApp.id === app.id
                });
                newContent = state.content;
                newContent[index] = action.payload;
                newIndex = index;
            } else {
                newContent = [
                    ...state.content,
                    action.payload
                ];
                newIndex = newContent.length - 1;
            }

            return {
                ...state,
                pending: false,
                sending: false,
                error: null,
                content: newContent,
                currentApplication: action.payload,
                currentIndex: newIndex
            };
        case APPS_DOWNLOADED:
            let newAppDownloadedState = {
                ...state,
                pending: false,
                sending: false,
                error: null,
                content: action.payload,
            };

            if (state.currentApplication) {
                let newCurrentApplication = state.content.find(function (app) {
                    return app.id === state.currentApplication.id
                });
                if (newCurrentApplication) {
                    newAppDownloadedState.currentApplication = newCurrentApplication;
                    newAppDownloadedState.currentIndex = newAppDownloadedState.content.findIndex((app) => {
                        return newCurrentApplication.id === app.id
                    });
                }
            } else {
                newAppDownloadedState.currentApplication = null;
                newAppDownloadedState.currentIndex = null;
            }

            return newAppDownloadedState;
        case APPS_FAILED:
            return {
                ...state,
                pending: false,
                sending: false,
                error: action.payload
            };
        case APP_FAILED:
            return {
                ...state,
                pending: false,
                sending: false,
                error: action.payload
            };
        case APP_POSTING:
            return {
                ...state,
                sending: true
            };
        case APP_EDITING:
            return {
                ...state,
                sending: true
            };
        case APP_DELETING:
            return {
                ...state,
                sending: true
            };

        case APP_PICTURE_UPLOADING:
            return {
                ...state,
                sending: true
            };
        case APP_PICTURE_FAILED:
            return {
                ...state,
                pending: false,
                sending: false,
                error: action.payload
            };
        case APP_PICTURE_UPLOADED:
            return {
                ...state,
                pending: false,
                sending: false
            };
        case APP_PICTURE_DELETING:
            return state;
        default:
            break;
    }

    return state;
}



// WEBPACK FOOTER //
// src/store/apps/reducers.js